import { fetchClientConfig } from '@reinz/auth/clientConfig'

// ConfigService.ts
const CONFIG_STORAGE_KEY = 'appConfig'
const STORAGE_EXPIRATION_KEY = 'configExpiration'
const EXPIRATION_DURATION_MS = 24 * 60 * 60 * 1000 // 24h

let appConfig: any | null = null

const hasSessionStorage = () =>
  typeof window !== 'undefined' && typeof sessionStorage !== 'undefined'

const isConfigExpired = () => {
  if (!hasSessionStorage()) return true
  const expirationTime = sessionStorage.getItem(STORAGE_EXPIRATION_KEY)
  return !expirationTime || Date.now() > parseInt(expirationTime, 10)
}

const fetchConfigFromServer = async () => {
  const config = await fetchClientConfig()

  if (hasSessionStorage()) {
    sessionStorage.setItem(CONFIG_STORAGE_KEY, JSON.stringify(config))
    sessionStorage.setItem(STORAGE_EXPIRATION_KEY, String(Date.now() + EXPIRATION_DURATION_MS))
  }

  return config
}

export const fetchConfig = async () => {
  if (appConfig) return appConfig

  if (hasSessionStorage()) {
    const stored = sessionStorage.getItem(CONFIG_STORAGE_KEY)
    if (stored && !isConfigExpired()) {
      appConfig = JSON.parse(stored)
      return appConfig
    }
  }

  appConfig = await fetchConfigFromServer()
  return appConfig
}

export const getAppConfig = () => appConfig

export const clearConfig = () => {
  //Clear in-memory cache
  appConfig = null

  if (hasSessionStorage()) {
    sessionStorage.removeItem(CONFIG_STORAGE_KEY)
    sessionStorage.removeItem(STORAGE_EXPIRATION_KEY)
  }
}
